// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    Guitar,
    Ham,
    Hamburger,
    Hammer,
    Hand,
    HandCoins,
    HandFist,
    HandGrab,
    HandHeart,
    HandHelping,
    HandMetal,
    HandPlatter,
    Handbag,
    Handshake,
    HardDrive,
    HardDriveDownload,
    HardDriveUpload,
    HardHat,
    Hash,
    HatGlasses,
    Haze,
    Hd,
    HdmiPort,
    Heading,
    Heading1,
    Heading2,
    Heading3,
    Heading4,
    Heading5,
    Heading6,
    HeadphoneOff,
    Headphones,
    Headset,
    Heart,
    HeartCrack,
    HeartHandshake,
    HeartMinus,
    HeartOff,
    HeartPlus,
    HeartPulse,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "guitar" through "heart-pulse", inclusive. */
const shard: Record<string, LucideIcon> = {
    guitar: Guitar,
    ham: Ham,
    hamburger: Hamburger,
    hammer: Hammer,
    hand: Hand,
    "hand-coins": HandCoins,
    "hand-fist": HandFist,
    "hand-grab": HandGrab,
    "hand-heart": HandHeart,
    "hand-helping": HandHelping,
    "hand-metal": HandMetal,
    "hand-platter": HandPlatter,
    handbag: Handbag,
    handshake: Handshake,
    "hard-drive": HardDrive,
    "hard-drive-download": HardDriveDownload,
    "hard-drive-upload": HardDriveUpload,
    "hard-hat": HardHat,
    hash: Hash,
    "hat-glasses": HatGlasses,
    haze: Haze,
    hd: Hd,
    "hdmi-port": HdmiPort,
    heading: Heading,
    "heading-1": Heading1,
    "heading-2": Heading2,
    "heading-3": Heading3,
    "heading-4": Heading4,
    "heading-5": Heading5,
    "heading-6": Heading6,
    "headphone-off": HeadphoneOff,
    headphones: Headphones,
    headset: Headset,
    heart: Heart,
    "heart-crack": HeartCrack,
    "heart-handshake": HeartHandshake,
    "heart-minus": HeartMinus,
    "heart-off": HeartOff,
    "heart-plus": HeartPlus,
    "heart-pulse": HeartPulse,
};

export default shard;
